var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccentSidebar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 481,
    viewBox: "0 0 263 481",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -306.084,
    y: 466.773,
    width: 543,
    height: 77.5714,
    rx: 38.7857,
    transform: "rotate(-45 -306.084 466.773)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -141.53,
    y: 631.327,
    width: 543,
    height: 77.5714,
    rx: 38.7857,
    transform: "rotate(-45 -141.53 631.327)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -87.064,
    y: 411.545,
    width: 310.286,
    height: 77.5714,
    rx: 38.7857,
    transform: "rotate(45 -87.064 411.545)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -86.6841,
    y: 82.8267,
    width: 543,
    height: 77.5714,
    rx: 38.7857,
    transform: "rotate(45 -86.6841 82.8267)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccentSidebar);
export default __webpack_public_path__ + "static/media/accent-sidebar.b09d7cb829a2358cd7a542ef4e34aaea.svg";
export { ForwardRef as ReactComponent };